export const ABILITIES = Object.freeze({
  dragonArc: Object.freeze({
    key: 'dragonArc',
    name: 'Dragon Arc',
    shortcut: 'Q',
    cooldownMs: 1800,
    range: 190,
    damageMultiplier: 1.65,
    maxTargets: 5,
    description: 'A wide crimson cut that strikes nearby corruption.'
  }),
  ashStep: Object.freeze({
    key: 'ashStep',
    name: 'Ash Step',
    shortcut: 'Shift',
    cooldownMs: 1400,
    distance: 155,
    description: 'A short evasive step through danger.'
  })
});

export const OBJECTIVES = Object.freeze([
  Object.freeze({
    key: 'first_blood',
    title: 'First Blood',
    text: 'Defeat one corrupted creature beyond Crimson Rest.',
    metric: 'kills',
    target: 1,
    hint: 'Walk through the south gate. Select a creature and press Space.'
  }),
  Object.freeze({
    key: 'claim_the_ash',
    title: 'Claim the Ash',
    text: 'Collect one drop from the frontier.',
    metric: 'loot',
    target: 1,
    hint: 'Stand near a marked drop and press F.'
  }),
  Object.freeze({
    key: 'break_the_vein',
    title: 'Break the Vein',
    text: 'Destroy a Dragon Vein Monolith and survive its waves.',
    metric: 'monoliths',
    target: 1,
    hint: 'Follow the red mark on the minimap to Dragon Quarry.'
  }),
  Object.freeze({
    key: 'temper_the_blade',
    title: 'Temper the Blade',
    text: 'Use the forge at Crimson Rest to improve equipped gear.',
    metric: 'upgrades',
    target: 1,
    hint: 'Return to the brass forge near the campfire.'
  }),
  Object.freeze({
    key: 'face_the_warden',
    title: 'Face the Warden',
    text: 'Defeat the Crimson Warden in the quarry arena.',
    metric: 'bosses',
    target: 1,
    hint: 'The Warden waits beyond the second monolith.'
  }),
  Object.freeze({
    key: 'choose_mastery',
    title: 'Choose Mastery',
    text: 'Return to Crimson Rest and claim your next mastery mark.',
    metric: 'mastery',
    target: 1,
    hint: 'Use the mastery seal in the camp when you are ready to continue.'
  })
]);

export const FORGE_COSTS = Object.freeze([2, 4, 7]);

export function normalizeProgression(value = {}) {
  const source = value && typeof value === 'object' ? value : {};
  return {
    version: 1,
    step: Math.max(0, Math.min(OBJECTIVES.length, Math.trunc(source.step || 0))),
    kills: Math.max(0, Math.trunc(source.kills || 0)),
    loot: Math.max(0, Math.trunc(source.loot || 0)),
    monoliths: Math.max(0, Math.trunc(source.monoliths || 0)),
    upgrades: Math.max(0, Math.trunc(source.upgrades || 0)),
    bosses: Math.max(0, Math.trunc(source.bosses || 0)),
    mastery: Math.max(0, Math.trunc(source.mastery || 0)),
    embers: Math.max(0, Math.trunc(source.embers || 0)),
    upgradesBySlot: {
      weapon: Math.max(0, Math.min(3, Math.trunc(source.upgradesBySlot?.weapon || 0))),
      armor: Math.max(0, Math.min(3, Math.trunc(source.upgradesBySlot?.armor || 0))),
      charm: Math.max(0, Math.min(3, Math.trunc(source.upgradesBySlot?.charm || 0)))
    }
  };
}

export function objectiveState(progression) {
  const normalized = normalizeProgression(progression);
  const definition = OBJECTIVES[normalized.step] || null;
  if (!definition) return { ...normalized, objective: null, complete: true };
  const value = normalized[definition.metric] || 0;
  return {
    ...normalized,
    objective: {
      ...definition,
      value: Math.min(definition.target, value),
      complete: value >= definition.target
    },
    complete: false
  };
}
